import { PublicPageContent, Typography, WithGap } from '@/components'
import { isArray, isString } from '@/utils'
import { reject } from 'ramda'
import { useTranslation } from 'react-i18next'
import { Container } from './styles'

interface SubSubContent {
  subsubtitle: string
  content: string[]
}

interface SubContent {
  subtitle: string
  content: string | string[] | SubSubContent[]
}

interface PolicyContent {
  title: string
  content: string | string[] | SubContent[]
}

export const PolicyPage = () => {
  const { t } = useTranslation()
  const content = t('privacyPolicy.content', {
    returnObjects: true,
  }) as PolicyContent[]

  return (
    <PublicPageContent>
      <Container>
        <WithGap gap={6}>
          <Typography responsive variant="h1">
            {t('privacyPolicy.title')}
          </Typography>
          {content.map(({ title, content }, i: number) => (
            <div key={i}>
              <Typography responsive variant="h3">
                {i + 1} {title}
              </Typography>
              {isString(content) ? (
                <Typography variant="p1Body">{content}</Typography>
              ) : (
                (content as (string | string[] | SubContent)[]).map(
                  (item: string | string[] | SubContent, j: number) =>
                    isString(item) ? (
                      <Typography key={j} variant="p1Body">
                        {item}
                      </Typography>
                    ) : isArray(item) ? (
                      <ul key={j}>
                        {item.map((subItem: string | string[], l: number) =>
                          isString(subItem) ? (
                            <li key={l}>
                              <Typography variant="p1Body">
                                {subItem}
                              </Typography>
                            </li>
                          ) : (
                            <ul key={l}>
                              {subItem.map((listItem: string, m: number) => (
                                <li key={m}>
                                  <Typography variant="p1Body">
                                    {listItem}
                                  </Typography>
                                </li>
                              ))}
                            </ul>
                          ),
                        )}
                      </ul>
                    ) : (
                      <div key={j}>
                        <Typography responsive variant="h3">
                          {i + 1}.
                          {j +
                            1 -
                            reject((x: any) => !x.subtitle, content as any[])
                              .length}{' '}
                          {item.subtitle}
                        </Typography>
                        {isString(item.content) ? (
                          <Typography variant="p1Body">
                            {item.content}
                          </Typography>
                        ) : (
                          (item.content as (
                            | string
                            | string[]
                            | SubSubContent
                          )[]).map(
                            (
                              subItem: string | string[] | SubSubContent,
                              k: number,
                            ) =>
                              isString(subItem) ? (
                                <Typography key={k} variant="p1Body">
                                  {subItem}
                                </Typography>
                              ) : isArray(subItem) ? (
                                <ul key={k}>
                                  {subItem.map((listItem: string, l: number) =>
                                    isString(listItem) ? (
                                      <li key={l}>
                                        <Typography variant="p1Body">
                                          {listItem}
                                        </Typography>
                                      </li>
                                    ) : (
                                      <ul key={l}>
                                        {(listItem as string[]).map(
                                          (subListItem: string, m: number) => (
                                            <li key={m}>
                                              <Typography variant="p1Body">
                                                {subListItem}
                                              </Typography>
                                            </li>
                                          ),
                                        )}
                                      </ul>
                                    ),
                                  )}
                                </ul>
                              ) : (
                                <div key={k}>
                                  <Typography responsive variant="h3">
                                    {i + 1}.{j + 1}.{k + 1}{' '}
                                    {subItem.subsubtitle}
                                  </Typography>
                                  {subItem.content.map(
                                    (text: string, n: number) => (
                                      <Typography key={n} variant="p1Body">
                                        {text}
                                      </Typography>
                                    ),
                                  )}
                                </div>
                              ),
                          )
                        )}
                      </div>
                    ),
                )
              )}
            </div>
          ))}
        </WithGap>
      </Container>
    </PublicPageContent>
  )
}
